var

EntityStatus = /*#__PURE__*/function (EntityStatus) {EntityStatus["New"] = "new";EntityStatus["Processing"] = "processing";EntityStatus["Obsolete"] = "obsolete";EntityStatus["Error"] = "error";EntityStatus["Processed"] = "processed";return EntityStatus;}(EntityStatus || {});





















































































































export { EntityStatus };